import { AUTH_FEATURE_KEY } from './auth.selectors';
import { AuthConfigService } from '../data-access/auth-config.service';
import { AuthEffects } from './auth.effects';
import { AuthGuard } from '../data-access/auth.guard';
import { authReducer } from './auth.reducer';
import { AuthService } from '../data-access/auth.service';
import { AuthStoreService } from '../data-access/auth-store.service';
import { NonAuthGuard } from '../data-access/non-auth.guard';
import { TokenStorageService } from '../data-access/token-storage.service';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { isDevMode } from '@angular/core';

export function provideAuth() {
  return [
    AuthService,
    TokenStorageService,
    AuthStoreService,
    AuthConfigService,
    AuthGuard,
    NonAuthGuard,

    provideStore(),
    provideState(AUTH_FEATURE_KEY, authReducer),
    provideEffects([AuthEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
  ];
}
